<template>
  <v-app class="back" :style="this.$customStyle">
    <router-view />

    <v-overlay :value="carregando">
      <v-progress-circular
          :size="80"
          :width="5"
          color="#BC0000"
          indeterminate
      ></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js"></script>
<script src="https://unpkg.com/axios/dist/axios.min.js"></script>
<script>
import Vue from "vue";

export default {
  name: "App",
  data: () => ({
    carregando: false
  }),
  created () {
    Vue.$globalEvent.$on("loader", (item) => {
      this.carregando = item;
    });
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,200;0,300;0,400;1,100;1,200;1,300;1,400&display=swap");
html,
body,
* {
  box-sizing: border-box !important;
  font-family: "Poppins" !important;
}

body::-webkit-scrollbar {
  background-color: #e9e9e9;
  width: 12px;
}

body::-webkit-scrollbar-thumb {
  background-color: rgba(114, 119, 131, 0.5);
  border-radius: 20px;
}

.back {
  background: #eeeeee !important;
}

.v-dialog::-webkit-scrollbar {
  background-color: #e9e9e9;
  width: 10px;
  border-radius: 3.5px;
}

.v-dialog::-webkit-scrollbar-thumb {
  background: #c4c4c4;
  border-radius: 3.5px;
}

.v-data-table__wrapper {
  border-top: none;
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.15px;

  color: rgba(0, 0, 0, 1);

  border-radius: 3px !important;
}

.v-data-table__mobile-row {
  border: none !important;
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.15px;
  color: rgba(0, 0, 0, 1);

  border-radius: 3px !important;
}

#productTable {
  box-sizing: border-box;
  padding: 10px;
}

#productTable > .v-data-table__wrapper > table > thead {
  padding: 10px;
  margin-bottom: 10px;
}

#productTable > .v-data-table__wrapper > table > thead > tr {
  background: #f5f5f5;
  border-radius: 4px;
}

#productTable > .v-data-table__wrapper > table > thead > tr:last-child > th {
  border: none;
}

#productTable > .v-data-table__wrapper > table > thead > tr > th {
  font-weight: bold;
  font-size: 15px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: rgba(45, 48, 56, 0.5);
}

#productTable > .v-data-table__wrapper > table > tbody > tr > td {
  font-weight: 300;
  font-size: 15px;
  line-height: 19px;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

#category-table {
  box-sizing: border-box;
  padding: 10px;
}

#category-table > .v-data-table__wrapper > table > thead {
  padding: 10px;
  margin-bottom: 10px;
}

#category-table > .v-data-table__wrapper > table > thead > tr {
  background: #f5f5f5;
  border-radius: 4px;
}

#category-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  border: none;
}

#category-table > .v-data-table__wrapper > table > thead > tr > th {
  font-weight: bold;
  font-size: 15px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: rgba(45, 48, 56, 0.5);
}

#category-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-weight: 300;
  font-size: 15px;
  line-height: 19px;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

#attribute-table {
  box-sizing: border-box;
  padding: 10px;
}

#attribute-table > .v-data-table__wrapper > table > thead {
  padding: 10px;
  margin-bottom: 10px;
}

#attribute-table > .v-data-table__wrapper > table > thead > tr {
  background: #f5f5f5;
  border-radius: 4px;
}

#attribute-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  border: none;
}

#attribute-table > .v-data-table__wrapper > table > thead > tr > th {
  font-weight: bold;
  font-size: 15px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: rgba(45, 48, 56, 0.5);
}

#attribute-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-weight: 300;
  font-size: 15px;
  line-height: 19px;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

#attributegroup-table {
  box-sizing: border-box;
  padding: 10px;
}

#attributegroup-table > .v-data-table__wrapper > table > thead {
  padding: 10px;
  margin-bottom: 10px;
}

#attributegroup-table > .v-data-table__wrapper > table > thead > tr {
  background: #f5f5f5;
  border-radius: 4px;
}

#attributegroup-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  border: none;
}

#attributegroup-table > .v-data-table__wrapper > table > thead > tr > th {
  font-weight: bold;
  font-size: 15px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: rgba(45, 48, 56, 0.5);
}

#attributegroup-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-weight: 300;
  font-size: 15px;
  line-height: 19px;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

#product-resale-table {
  box-sizing: border-box;
  padding: 10px;
}

#product-resale-table > .v-data-table__wrapper > table > thead {
  padding: 10px;
  margin-bottom: 10px;
}

#product-resale-table > .v-data-table__wrapper > table > thead > tr {
  background: #f5f5f5;
  border-radius: 4px;
}

#product-resale-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  border: none;
}

#product-resale-table > .v-data-table__wrapper > table > thead > tr > th {
  font-weight: bold;
  font-size: 15px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: rgba(45, 48, 56, 0.5);
}

#product-resale-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-weight: 300;
  font-size: 15px;
  line-height: 19px;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

#skus-table {
  box-sizing: border-box;
  padding: 10px;
}

#skus-table > .v-data-table__wrapper > table > thead {
  padding: 10px;
  margin-bottom: 10px;
}

#skus-table > .v-data-table__wrapper > table > thead > tr {
  background: #f5f5f5;
  border-radius: 4px;
}

#skus-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  border: none;
}

#skus-table > .v-data-table__wrapper > table > thead > tr > th {
  font-weight: bold;
  font-size: 15px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: rgba(45, 48, 56, 0.5);
}

#skus-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-weight: 300;
  font-size: 15px;
  line-height: 19px;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

#resale-profile-table {
  box-sizing: border-box;
  padding: 10px;
}

#resale-profile-table > .v-data-table__wrapper > table > thead {
  padding: 10px;
  margin-bottom: 10px;
}

#resale-profile-table > .v-data-table__wrapper > table > thead > tr {
  background: #f5f5f5;
  border-radius: 4px;
}

#resale-profile-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  border: none;
}

#resale-profile-table > .v-data-table__wrapper > table > thead > tr > th {
  font-weight: bold;
  font-size: 15px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: rgba(45, 48, 56, 0.5);
}

#resale-profile-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-weight: 300;
  font-size: 15px;
  line-height: 19px;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

#product-profile-table {
  box-sizing: border-box;
  padding: 10px;
}

#product-profile-table > .v-data-table__wrapper > table > thead {
  padding: 10px;
  margin-bottom: 10px;
}

#product-profile-table > .v-data-table__wrapper > table > thead > tr {
  background: #f5f5f5;
  border-radius: 4px;
}

#product-profile-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  border: none;
}

#product-profile-table > .v-data-table__wrapper > table > thead > tr > th {
  font-weight: bold;
  font-size: 15px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: rgba(45, 48, 56, 0.5);
}

#product-profile-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-weight: 300;
  font-size: 15px;
  line-height: 19px;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}
</style>
